import { mapPriceField } from '@/shared/utils/priceFormatter';
import type { ProductCustomization } from '../../domain/models/ProductCustomization';
import type { CustomizationResponseDTO } from '../dto/customization.dto';
import { normalizeNumericField } from '@/features/pdp/utils/normalizeNumericField';

function normalizeGemstonesField(
  value: string | Array<{ count?: number; type?: string }> | null | undefined
): string | null {
  if (!value) return null;
  if (Array.isArray(value)) {
    return value.length > 0 ? JSON.stringify(value) : null;
  }
  return value;
}

export function customizationDtoToProductCustomization(dto: CustomizationResponseDTO): ProductCustomization {
  return {
    customizationId: dto.customizationId ?? 0,

    price: mapPriceField(dto.price),
    discountedPrice: mapPriceField(dto.discountedPrice),
    discountValue: mapPriceField(dto.discountValue),
    discountPercent: dto.discountPercent ?? null,
    discountName: dto.discountName ?? null,
    flatDiscountPercent: dto.flatDiscountPercent ?? null,

    goldPrice: mapPriceField(dto.goldPrice, dto.goldSellingPrice),
    diamondPrice: mapPriceField(dto.diamondPrice, dto.diamondSellingPrice),
    diamondPriceAfterDiscount: mapPriceField(dto.diamondPriceAfterDiscount),
    discountOnDiamondPriceValue: dto.discountOnDiamondPriceValue ?? null,
    gemstonePrice: mapPriceField(dto.gemstonePrice, dto.coloredStoneSellingPrice),
    presetSolitairePrice: mapPriceField(dto.presetSolitairePrice, dto.presetSolitaireSellingPrice),
    makingChargePrice: mapPriceField(dto.makingChargePrice),
    makingChargePriceAfterDiscount: mapPriceField(dto.makingChargePriceAfterDiscount),
    makingChargeDiscountValue: dto.makingChargeDiscountValue ?? null,
    gst: mapPriceField(dto.gst, dto.gstPrice),

    metal: dto.metal ?? '',
    metalType: dto.metalType ?? '',
    goldPurity: dto.goldPurity ?? null,
    metalWeight: dto.metalWeight ?? 0,
    productWeight: normalizeNumericField(dto.productWeight),
    diamondStoneType: dto.diamondStoneType ?? null,
    diamondCarat: normalizeNumericField(dto.diamondCarat),
    noOfDiamonds: normalizeNumericField(dto.totalDiamonds),
    solitaireCarat: normalizeNumericField(dto.solitaireCarat ?? dto.solitaireTotalCarat),
    gemstonesTypeAndCount: normalizeGemstonesField(dto.gemstonesTypeAndCount),
    shortDesc: dto.shortDesc ?? null,
  };
}
